<template>
  <div v-if="videoWall.visible" class="image-wall">
    <div class="image-wall-wrapper">
      <video class="video" :src="videoWall.url | filterImage" controls muted />
      <div @click="$store.commit('HIDDEN_VIDEO_WALL')" class="wall-close">
        <i class="el-icon-close" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      videoWall: (state) => state.app.videoWall
    })
  }
}
</script>

<style lang="scss" scoped>
.image-wall {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);

  .image-wall-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    .video {
      max-width: 50vw;
    }

    .wall-close {
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 2;
      width: 40px;
      height: 40px;
      border-radius: 40px;
      text-align: center;
      background-color: rgba(255, 255, 255, 0.7);
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.7);
      cursor: pointer;

      .el-icon-close {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      &:hover {
        background-color: #fff;
      }
    }
  }
}
</style>
